import { RecurringScopeDialogProps } from '@/routes/calendar/CalendarPage.types'
import { Button, Popup } from 'devextreme-react'

const RecurringScopeDialog = ({ open, action, onSelect, onCancel }: RecurringScopeDialogProps) => {
  const title = action === 'delete' ? 'Elimina' : 'Modifica'

  return (
    <Popup
      visible={open}
      title={title}
      width={'auto'}
      height="auto"
      showCloseButton={true}
      hideOnOutsideClick={false}
      dragEnabled={true}
      onHiding={onCancel}
    >
      <div>
        <div className="recurring-scope-dialog-buttons">
          <Button
            text={'Singolo appuntamento'}
            type="default"
            stylingMode="outlined"
            onClick={() => onSelect('appointment')}
          />
          <Button text={'Tutta la serie'} type="default" stylingMode="outlined" onClick={() => onSelect('series')} />
          <Button text="Annulla" type="default" stylingMode="outlined" onClick={onCancel} />
        </div>
      </div>
    </Popup>
  )
}

export default RecurringScopeDialog
